import { Flex, Icon } from '@chakra-ui/react'
import { Th, Tr } from '../../components/Table'
import { IoIosArrowDown } from 'react-icons/io'
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta'
import { user } from '../../helpers/user'

export function Columns({ orderBy, ordered }) {
    return (
        <Tr>
            <Th py={2} bgColor="#378BBF" w="75px">
                <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('abertura_order', 'date')} cursor="pointer">
                    Data
                    <Icon as={IoIosArrowDown} transition="transform 0.3s" transform={ordered.column === 'abertura_order' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'} />
                </Flex>
            </Th>
            <Th py={2} bgColor="#378BBF" width="100px">
                Proposta
            </Th>
            {permissoesUsuariosPropostas[user.codigo_usuario] && (
                <Th py={2} bgColor="#378BBF" width="100px">
                    Consultor
                </Th>
            )}

            <Th py={2} bgColor="#378BBF" width="147px">
                Cliente
            </Th>

            <Th py={2} bgColor="#378BBF" w="89px">
                Valor <br /> Proposta
            </Th>
            <Th py={2} bgColor="#378BBF" w="45px">
                <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('prazo')} cursor="pointer">
                    Prazo
                    <Icon as={IoIosArrowDown} transition="transform 0.3s" transform={ordered.column === 'prazo' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'} />
                </Flex>
            </Th>

            <Th py={2} bgColor="#378BBF" w="89px">
                Layout Enviado
            </Th>

            <Th bgColor="#378BBF" w="112px">
                Aprovado em
            </Th>
            <Th bgColor="#378BBF" w="112px">
                Passo Atual
            </Th>
            <Th bgColor="#378BBF" w="112px">
                Nota fiscal
            </Th>

            <Th bgColor="#378BBF" w="112px">
                Cond. Pagamento
            </Th>

            <Th bgColor="#378BBF" w="112px">
                Empresa
            </Th>

            <Th bgColor="#378BBF" w="112px">
                Tipo frete
            </Th>
            <Th bgColor="#378BBF" w="112px">
                Data saída
            </Th>
            <Th bgColor="#378BBF" w="90px" />
        </Tr>
    )
}
